export default defineNuxtRouteMiddleware(async to => {
  if (process.server) { return }

  // Shoptoken
  if (
    to.query?.shoptoken
  ) {
    useCartStore().shopToken = to.query?.shoptoken?.toString()
  }

  if (to.query?.clearshoptoken) {
    useCartStore().shopToken = null
  }

  // Coupon code
  const code = to.query?.c?.toString() || to.query?.C?.toString()
  if (code && !to.name?.toString().includes('cart')) { // Cart pages handles adding coupon itself
    const paymentStore = usePaymentStore()
    const { $t } = useNuxtApp()
    const { showToast } = useToast()
    try {
      const data = await paymentStore.addCoupon(code)
      if (data) {
        await showToast({
          id: 'coupon',
          message: $t('general/coupon-added-to-shoppingbag', {
            KORTINGSCODE: code
          })
        })
      }
    } catch (e) {
      console.log(e)
    }
  }
})
